<div class="dropdown-wrap">
  <label>基金名稱</label>
  <div class="dropdown" *ngIf="inputFundSelectList.length">
    <p-dropdown optionLabel="FundShortName" [options]="inputFundSelectList" [(ngModel)]="selectedFund" (onChange)="onFundChange($event)"></p-dropdown>
  </div>
</div>
<div class="search-wrap">
  <div class="calendar-item">
    <label>開始時間</label>
    <div class="calendar-wrap">
      <img class="calendar-icon" src="/assets/images/calendar.svg" alt="月曆圖示" />
      <p-calendar class="calendar" dateFormat="yy/mm/dd" placeholder="年/月/日"  [(ngModel)]="startDate" (onSelect)="onStartDateChange($event)"></p-calendar>
    </div>
  </div>
  <div class="calendar-item end-date-calendar">
    <label>結束時間</label>
    <div class="calendar-wrap">
      <img class="calendar-icon" src="/assets/images/calendar.svg" alt="月曆圖示" />
      <p-calendar class="calendar" dateFormat="yy/mm/dd" placeholder="年/月/日" [(ngModel)]="endDate" (onSelect)="onEndDateChange($event)"></p-calendar>
    </div>
  </div>
  <button (click)="search()">查詢</button>
</div>


<app-message-dialog *ngIf="visible" [visible]="visible" [data]="dialogData" [privateType]="visibleType"
  (visibleChange)="visibleChange($event)"></app-message-dialog>
